import dataFormatter from '@/shared/data_formatter';
import resources from '../resources';
import * as types from './mutation-types';

export const getAuctionsCatalog = ({ commit }) => {
  resources.AuctionsCatalog.get().then((response) => {
    const deserializedData = dataFormatter.deserialize(response.body);
    commit(types.UPDATE_AUCTIONS_CATALOG, { auctionsCatalog: deserializedData });
  }, () => {});
};

export const getArtworks = ({ commit }, params) => {
  resources.Artworks.get(params).then((response) => {
    const deserializedData = dataFormatter.deserialize(response.body);
    commit(types.UPDATE_ARTWORKS, { artworks: deserializedData });
    commit(types.UPDATE_META, { meta: response.body.meta });
  }, () => {});
};

export const getCurrentUser = ({ commit }) => {
  resources.User.get().then((response) => {
    const deserializedData = dataFormatter.deserialize(response.body);

    commit(types.SET_CURRENT_USER_ID, parseInt(deserializedData.id, 10));
  }, () => {});
};



// WEBPACK FOOTER //
// ./app/javascript/packs/auctions_catalogs/show/store/actions.js